import { setTimeActivityType as setTimeActivityTypeDiagram } from '@process-advisor/process-miner/processMiner/processMiner';
import type { ApiMethodBase } from '@process-advisor/process-miner/api/types';
import { Event } from '@process-advisor/process-miner/api/events';

export type Props = ApiMethodBase & {
    activity?: String,
}

export const setTimeActivityType = ({
    activity,
    eventEmitter
}: Props) => {
    setTimeActivityTypeDiagram(activity);
};



